import { render, staticRenderFns } from "./WeeklyHot.vue?vue&type=template&id=11273ed0&scoped=true&"
import script from "./WeeklyHot.vue?vue&type=script&lang=js&"
export * from "./WeeklyHot.vue?vue&type=script&lang=js&"
import style0 from "./WeeklyHot.vue?vue&type=style&index=0&id=11273ed0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11273ed0",
  null
  
)

export default component.exports